import DOMPurify from 'dompurify';

/**
 * Shared HTML sanitizer for TinyMCE notes and other rich-text sinks.
 * Matches FormatHtmlTextToReact (DOMPurify) plus extra forbidden tags so
 * stored XSS payloads like <img onerror> / <iframe> cannot reach the DOM.
 */
const RICH_HTML_PURIFY_CONFIG: DOMPurify.Config = {
  ADD_ATTR: ['target'],
  FORBID_TAGS: [
    'script',
    'iframe',
    'object',
    'embed',
    'form',
    'link',
    'meta',
    'base',
    'svg',
    'math',
    'video',
    'audio',
    'img',
  ],
};

export const sanitizeRichHtml = (html?: string | null): string => {
  if (!html) {
    return '';
  }
  return DOMPurify.sanitize(html, RICH_HTML_PURIFY_CONFIG);
};
